import { useContextSelector } from "use-context-selector";
import { VideoChatContext } from "../context/VideoChatContext";

export const useRoom = () => {
  const room = useContextSelector(VideoChatContext, (context) => context.room);
  const localTracks = useContextSelector(VideoChatContext, (context) => context.localTracks);
  const connected = useContextSelector(VideoChatContext, (context) => context.connected);
  const handleSetConnected = useContextSelector(
    VideoChatContext,
    (context) => context.handleSetConnected
  );
  const currentFocused = useContextSelector(VideoChatContext, (context) => context.currentFocused);
  const focusedParticipantRef = useContextSelector(
    VideoChatContext,
    (context) => context.focusedParticipantRef
  );

  const setRoom = useContextSelector(VideoChatContext, (context) => context.handleSetRoom);
  const handleLeaveRoom = useContextSelector(
    VideoChatContext,
    (context) => context.handleLeaveRoom
  );

  const handleChangeFocused = useContextSelector(
    VideoChatContext,
    (context) => context.handleChangeFocused
  );

  const focusedVideoOff = useContextSelector(
    VideoChatContext,
    (context) => context.focusedVideoOff
  );

  const handleFocusedVideoOff = useContextSelector(
    VideoChatContext,
    (context) => context.handleFocusedVideoOff
  );

  const isRecording = useContextSelector(VideoChatContext, (context) => context.isRecording);

  const handleRecording = useContextSelector(
    VideoChatContext,
    (context) => context.handleRecording
  );

  const setLocalTracks = useContextSelector(VideoChatContext, (context) => context.setLocalTracks);

  return {
    room,
    localTracks,
    currentFocused,
    focusedParticipantRef,
    setRoom,
    handleLeaveRoom,
    handleChangeFocused,
    connected,
    handleSetConnected,
    focusedVideoOff,
    handleFocusedVideoOff,
    isRecording,
    handleRecording,
    setLocalTracks,
  };
};
